module.exports = __webpack_public_path__ + "img/c00_buildingtechstonesaw_Normal_ua.e03bde2e.webp";